import {React, _} from '@api';
import {SpecItemView} from '@modules/pdf';
import {buildImageUrl} from '@utils';
import {styled} from '@pdf'

const RootView = styled.View`
  display:flex;
  flex-direction: column;
`

const TitleText = styled.Text`
  font-family: Helvetica;
  font-size:   6pt;
`

export class VlpSpecItemPdf extends React.Component<{ includeImage?: boolean, spec, style?: any, textStyle?: any, imageStyle?: any, hexStyle?: any }> {
  static defaultProps = {
    includeImage: true
  }

  render() {
    let {props: {spec, style, textStyle, hexStyle, imageStyle, includeImage}} = this

    if (!spec) return null
    spec                                     = {
      ...spec,
      title:    _.trim(spec.title) || _.trim(spec.name) || '--',
      subtitle: _.trim(spec.subtitle1) || '--',
      images:   spec.images && spec.images.length ? [buildImageUrl(spec.imagesRaw || spec.images)] : [],
      blank:    false,
    }
    const {title} = spec

    return (
        <RootView>
          <SpecItemView style={style}>
            <TitleText style={{maxLines:1,textOverflow:'ellipsis'}}>{title}</TitleText>
          </SpecItemView>
        </RootView> 
    )
  }
}


// WEBPACK FOOTER //
// ./src/modules/pdf/templates/vlp/VlpSpecItemPdf.tsx